import { render, staticRenderFns } from "./EmailEditorBrevo.vue?vue&type=template&id=46b1ee18&scoped=true"
import script from "./EmailEditorBrevo.vue?vue&type=script&lang=js"
export * from "./EmailEditorBrevo.vue?vue&type=script&lang=js"
import style0 from "./EmailEditorBrevo.vue?vue&type=style&index=0&id=46b1ee18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1ee18",
  null
  
)

export default component.exports